import React from 'react';
const Massage = () => <div className="service-page"><h1>Massage</h1><p>Professional massage therapy for relaxation and wellness.</p></div>;
export default Massage;
